// react core
import { useContext } from "react";

// imported animations
import Marquee from "react-fast-marquee";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// fonts
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning as iconInactive } from "@fortawesome/pro-duotone-svg-icons";
// import { faQrcode as iconTicket } from "@fortawesome/pro-duotone-svg-icons";
// import { faClose as iconClose } from "@fortawesome/pro-regular-svg-icons";

// entzy config and context
import configEntzy from "components/config/ConfigEntzy";
import { EventContext } from "components/event/EventContext";
import { TextTag } from "components/utils/common/CommonTags";

function EventFrameHeader(props) {
  const user = props.user;
  const eventContext = useContext(EventContext);

  return (
    <Box
      className="box-default"
      sx={{
        pt: configEntzy.APP_SPACING_MD2X,
        pb: configEntzy.APP_SPACING_MD,
      }}
    >
      {/* event url and tagline */}
      <Box
        className={
          "box-inline bg-black-t75" + (!user.connected ? " action-pointer" : "")
        }
        sx={{
          py: configEntzy.APP_SPACING_MD,
          px: configEntzy.APP_SPACING_MD2X,
          borderRadius: configEntzy.BORDER_SIZE_XL,
          maxWidth: "80%",
          overflow: "hidden",
        }}
        onClick={
          !user.connected
            ? () => {
                props.drawerConnectToggle();
              }
            : undefined
        }
      >
        <Typography variant="h5" className="lower-case" color="primary" noWrap>
          <span>{eventContext.state.event.urlComponents.pointer}</span>
          <span style={{ color: "white" }}>
            {eventContext.state.event.urlComponents.name}
          </span>
        </Typography>
        {eventContext.state.event.data.Tagline && (
          <Typography
            variant="subtitle2"
            sx={{ mt: configEntzy.APP_SPACING_SM }}
            noWrap
          >
            <span style={{ color: "white" }}>
              {eventContext.state.event.data.Tagline}
            </span>
          </Typography>
        )}
        {/* guest visitor message */}
        {eventContext.state.event.data.Active && !user.connected && (
          <Container
            maxWidth="xs"
            sx={{ mt: configEntzy.APP_SPACING_SM }}
            disableGutters
          >
            <Marquee speed={20} gradient={false}>
              <Typography variant="subtitle1" color="white">
                <span>Welcome to eventuator check-in</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span role="img" aria-label="wave">
                  👋
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {eventContext.state.event.data.Access === "public" ? (
                  <span>
                    Have a look around to see what's happening and connect to
                    place date offers when ready
                  </span>
                ) : (
                  <span>Connect to get started for private entry</span>
                )}
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span role="img" aria-label="eyes">
                  👀
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </Typography>
            </Marquee>
          </Container>
        )}
        {/* event inactive flag */}
        {!eventContext.state.event.data.Active && (
          <Typography variant="subtitle1">
            <TextTag
              text={
                <span>
                  <FontAwesomeIcon icon={iconInactive} color="darkorange" />
                  <span>&nbsp;&nbsp;</span>
                  <span>Eventuator is Inactive</span>
                  <span>&nbsp;&nbsp;</span>
                  <FontAwesomeIcon icon={iconInactive} color="darkorange" />
                </span>
              }
              size="md"
              bgColor="black"
              color="highlight.dark"
              rounded={true}
              edges={true}
            />
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default EventFrameHeader;
